__turbopack_context__.v({
  "Arrow": "NavBar-module-scss-module__JN4PfW__Arrow",
  "ArrowFill": "NavBar-module-scss-module__JN4PfW__ArrowFill",
  "ArrowInnerStroke": "NavBar-module-scss-module__JN4PfW__ArrowInnerStroke",
  "ArrowOuterStroke": "NavBar-module-scss-module__JN4PfW__ArrowOuterStroke",
  "Content": "NavBar-module-scss-module__JN4PfW__Content",
  "FlexLinkList": "NavBar-module-scss-module__JN4PfW__FlexLinkList",
  "GridLinkList": "NavBar-module-scss-module__JN4PfW__GridLinkList",
  "Icon": "NavBar-module-scss-module__JN4PfW__Icon",
  "IconTrigger": "NavBar-module-scss-module__JN4PfW__IconTrigger",
  "LinkCard": "NavBar-module-scss-module__JN4PfW__LinkCard",
  "LinkDescription": "NavBar-module-scss-module__JN4PfW__LinkDescription",
  "LinkTitle": "NavBar-module-scss-module__JN4PfW__LinkTitle",
  "List": "NavBar-module-scss-module__JN4PfW__List",
  "Popup": "NavBar-module-scss-module__JN4PfW__Popup",
  "Positioner": "NavBar-module-scss-module__JN4PfW__Positioner",
  "Root": "NavBar-module-scss-module__JN4PfW__Root",
  "Trigger": "NavBar-module-scss-module__JN4PfW__Trigger",
  "Viewport": "NavBar-module-scss-module__JN4PfW__Viewport",
  "linkDetails": "NavBar-module-scss-module__JN4PfW__linkDetails",
  "logoWrapper": "NavBar-module-scss-module__JN4PfW__logoWrapper",
  "menuItem": "NavBar-module-scss-module__JN4PfW__menuItem",
  "right": "NavBar-module-scss-module__JN4PfW__right",
  "signInWrapper": "NavBar-module-scss-module__JN4PfW__signInWrapper",
  "supportButton": "NavBar-module-scss-module__JN4PfW__supportButton",
});
